import * as React from 'react';
import { cn } from '@/lib/utils';

export interface DiagramFrameProps extends React.HTMLAttributes<HTMLDivElement> {
  caption?: React.ReactNode;
  /** Render in solid bg (default) or transparent over current surface. */
  variant?: 'solid' | 'transparent';
}

/**
 * DiagramFrame — wraps inline SVG diagrams (Glass Box, Signal Radar, GPS,
 * Power Grid, Benefit-or-Break, etc.) with a mono caption underneath.
 * The chrome is calm; the diagram inside carries the workshop-note style.
 */
export const DiagramFrame = React.forwardRef<HTMLDivElement, DiagramFrameProps>(
  ({ caption, variant = 'solid', className, children, ...rest }, ref) => (
    <figure
      ref={ref}
      className={cn(
        'rounded-fd border border-fd-border p-4',
        variant === 'solid' ? 'bg-fd-bg' : 'bg-transparent',
        className,
      )}
      {...rest}
    >
      <div className="block w-full [&_svg]:block [&_svg]:w-full [&_svg]:h-auto">{children}</div>
      {caption && (
        <figcaption className="mt-3 text-center font-geist-mono text-[10.5px] uppercase tracking-[0.06em] text-fd-text-subtle">
          {caption}
        </figcaption>
      )}
    </figure>
  ),
);
DiagramFrame.displayName = 'DiagramFrame';
